(function () {
  function getGroup(el) {
    return (el.closest && el.closest('.collapsible-content__grid, .product__accordion')) ||
           el.parentNode || document;
  }
  function closeOthers(group, keep) {
    var open = group.querySelectorAll('details[open]');
    for (var i = 0; i < open.length; i++) if (open[i] !== keep) open[i].removeAttribute('open');
  }
  document.addEventListener('toggle', function (e) {
    var item = e.target;
    if (!item || item.tagName !== 'DETAILS' || !item.open) return;
    closeOthers(getGroup(item), item);
  }, true);
  function normalize() {
    var groups = document.querySelectorAll('.collapsible-content__grid, .product__accordion');
    for (var g = 0; g < groups.length; g++) {
      var opened = groups[g].querySelectorAll('details[open]');
      for (var i = 1; i < opened.length; i++) opened[i].removeAttribute('open');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', normalize);
  else normalize();
})();
